import { render, staticRenderFns } from "./DashboardPanel.vue?vue&type=template&id=46846808&scoped=true"
import script from "./DashboardPanel.vue?vue&type=script&lang=ts"
export * from "./DashboardPanel.vue?vue&type=script&lang=ts"
import style0 from "./DashboardPanel.vue?vue&type=style&index=0&id=46846808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.9_css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_p_rtqrtxx4ab5lun7j52al72xaei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46846808",
  null
  
)

export default component.exports